import { Paper, withStyles } from "@material-ui/core";

const FormPaper = withStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(4, 3, 3, 3),
    backgroundColor: theme.palette.background.default
  }
}))(Paper);

const FormPaperAlt = withStyles(theme => ({
  root: {
    marginTop: theme.spacing(2),
    padding: theme.spacing(1, 3, 3, 3),
    backgroundColor: theme.palette.background.default
  }
}))(Paper);

const ListPaper = withStyles(theme => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(2),
    backgroundColor: theme.palette.background.default
  }
}))(Paper);

export { FormPaper, FormPaperAlt, ListPaper };
